import { render } from "./MemberInfoCard.vue?vue&type=template&id=3f8a0b7c&scoped=true"
import script from "./MemberInfoCard.vue?vue&type=script&lang=js"
export * from "./MemberInfoCard.vue?vue&type=script&lang=js"

import "./MemberInfoCard.vue?vue&type=style&index=0&id=3f8a0b7c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8a0b7c"]])

export default __exports__